import 'deepmerge';

function isValueInPixel(value) {
    return /^(\d)+px$/.test(value);
}
function isArFontSize(value) {
    return ['xl', 'lg', 'md', 'sm', 'xs', 'xxs', 'xxxs'].indexOf(value) > -1
        || isValueInPixel(value);
}

var ARText = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"ar-text",style:({
    height: _vm.textSectionHeight,
  }),attrs:{"ar-widget-id":"ar-text","ar-widget-meta":_vm.arWidgetMeta || _vm.computedArWidgetMeta,"name":"ar-text","title":_vm.elemTitle}},[(_vm.allowHtml)?_c('section',{ref:"text",class:[
      'text-section',
      (_vm.weight + "-weight") ],style:({
      transform: _vm.textSectionTranslateY,
    })},[_c('section',{staticClass:"text-section__inner",style:({
        display: _vm.textSectionDisplay,
        '-webkit-line-clamp': _vm.textSectionMaxLines,
        '-webkit-box-orient': _vm.textSectionBoxOrient,
        fontSize: _vm.fontSize,
        fontWeight: _vm.weight,
        lineHeight: _vm.textSectionLineHeight,
        textAlign: !_vm.direction ? _vm.textSectionTextAlign : null,
        whiteSpace: _vm.textSectionWhiteSpace,
        wordBreak: _vm.textSectionWordBreak,
        letterSpacing: _vm.letterSpacing,
        overflow: _vm.textSectionOverFlow,
      }),attrs:{"dir":_vm.direction},domProps:{"innerHTML":_vm._s(_vm.text)}})]):_c('section',{ref:"text",class:[
      'text-section',
      (_vm.weight + "-weight") ],style:({
      transform: _vm.textSectionTranslateY,
    })},[_c('section',{staticClass:"text-section__inner",style:({
        display: _vm.textSectionDisplay,
        '-webkit-line-clamp': _vm.textSectionMaxLines,
        '-webkit-box-orient': _vm.textSectionBoxOrient,
        fontSize: _vm.fontSize,
        fontWeight: _vm.weight,
        lineHeight: _vm.textSectionLineHeight,
        textAlign: !_vm.direction ? _vm.textSectionTextAlign : null,
        whiteSpace: _vm.textSectionWhiteSpace,
        wordBreak: _vm.textSectionWordBreak,
        letterSpacing: _vm.letterSpacing,
        overflow: _vm.textSectionOverFlow,
      }),attrs:{"dir":_vm.direction}},[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")])])])},
staticRenderFns: [],
  name: 'ARText',
  props: {
    arWidgetMeta: String,
    size: {
      type: String,
      default: 'md',
      validator: isArFontSize,
    },
    text: {
      type: [String, Number],
      default: null,
    },
    letterSpacing: {
      type: String,
      default: '0px',
    },
    allowHtml: {
      type: Boolean,
      default: false,
    },
    align: {
      type: String,
      default: 'left',
      validator: (value) =>
        ['left', 'right', 'center'].indexOf(value) !== -1,
    },
    weight: {
      type: String,
      default: 'normal',
      validator: (value) =>
        ['normal', 'bold'].indexOf(value) !== -1,
    },
    multipleLines: {
      type: Boolean,
      default: false,
    },
    lineHeight: {
      type: String,
      default: null,
    },
    maxLines: {
      type: Number,
      default: null,
    },
    anchorColor: {
      type: String,
      default: null,
    },
    direction: {
      type: String || null,
      default: null,
      validator: (value) =>
        ['auto', 'ltr', 'rtl', null].indexOf(value) !== -1,
    },
  },
  data() {
    return {
      isEllipsisActive: false,
    };
  },
  computed: {
    computedArWidgetMeta() {
      return [
        `text=${this.text};`,
      ].join('');
    },
    elemTitle() {
      if (!this.isEllipsisActive) {
        return null;
      }
      return this.text;
    },
    textSectionMaxLines() {
      if (this.multipleLines) {
        return this.maxLines || null;
      } else {
        return null;
      }
    },
    textSectionBoxOrient() {
      return this.multipleLines ? 'vertical' : null;
    },
    textSectionDisplay() {
      return this.multipleLines ? '-webkit-box' : 'block';
    },
    textSectionTextAlign() {
      return this.align;
    },
    fontSize() {
      return this.$arStyle.font.size[this.size] || this.size;
    },
    fontSizeInNumber() {
      return parseInt(this.fontSize, 10);
    },
    textSectionHeight() {
      return this.multipleLines ? null : this.fontSize;
    },
    textSectionWhiteSpace() {
      return this.multipleLines ? null : 'nowrap';
    },
    textSectionWordBreak() {
      if (this.multipleLines) {
        // If it's multiple lines but the max-lines is 1, we use `break-all`,
        // otherwise `break-word`.
        return this.maxLines === 1 ? 'break-all' : 'break-word';
      } else {
        return 'break-all';
      }
    },
    textSectionOverFlow() {
      return this.multipleLines ? null : 'hidden';
    },
    textSectionLineHeight() {
      if (this.multipleLines) {
        // For multiple lines, default line-height is "1.43"
        return this.lineHeight || '1.43';
      } else {
        // For single line, line-height is always "1.3"
        return '1.3';
      }
    },
    textSectionTranslateY() {
      let translatePixel = null;
      const isFireFox = navigator.userAgent.indexOf('Firefox') > -1;
      if (this.weight === 'bold' && this.multipleLines) {
        // Bold & Multiple Lines
        if (isFireFox) {
          translatePixel = this.fontSizeInNumber * 0.05;
        } else {
          translatePixel = this.fontSizeInNumber * 0;
        }
      } else if (this.weight === 'bold' && !this.multipleLines) {
        // Bold & Single Line
        if (isFireFox) {
          translatePixel = -this.fontSizeInNumber * 0.08;
        } else {
          switch (this.fontSizeInNumber) {
            case 14:
              translatePixel = -this.fontSizeInNumber * 0.06;
              break;
            case 30:
              translatePixel = -this.fontSizeInNumber * 0.11;
              break;
            default:
              translatePixel = -this.fontSizeInNumber * 0.08;
          }
        }
      } else if (this.weight !== 'bold' && this.multipleLines) {
        // Bold & Multiple Lines
        if (isFireFox) {
          translatePixel = this.fontSizeInNumber * 0.05;
        } else {
          switch (this.fontSizeInNumber) {
            case 14:
              translatePixel = -this.fontSizeInNumber * 0.06;
              break;
            default:
              translatePixel = -this.fontSizeInNumber * 0.07;
          }
        }
      } else if (this.weight !== 'bold' && !this.multipleLines) {
        // Bold & Single Line
        if (isFireFox) {
          translatePixel = -this.fontSizeInNumber * 0.11;
        } else {
          switch (this.fontSizeInNumber) {
            case 14:
              translatePixel = -this.fontSizeInNumber * 0.2;
              break;
            case 12:
              translatePixel = -this.fontSizeInNumber * 0.16;
              break;
            case 13:
              translatePixel = -this.fontSizeInNumber * 0.17;
              break;
            case 30:
              translatePixel = -this.fontSizeInNumber * 0.2;
              break;
            default:
              translatePixel = -this.fontSizeInNumber * 0.22;
          }
        }
      }
      return `translateY(${translatePixel}px)`;
    },
  },
  watch: {
    text() {
      if (this.allowHtml) {
        this.$nextTick(this.bindListenerToAnchors);
      }
      this.$nextTick(this.checkIsEllipsisActive);
    },
    allowHtml(val) {
      if (val) {
        this.bindListenerToAnchors();
      }
    },
  },
  mounted() {
    if (this.allowHtml) {
      this.bindListenerToAnchors();
    }
    this.checkIsEllipsisActive();
  },
  methods: {
    getTextElem() {
      return this.$refs.text;
    },
    checkIsEllipsisActive() {
      const textElem = this.getTextElem();
      if (!textElem) { return; }
      this.isEllipsisActive = textElem.clientWidth < textElem.scrollWidth;
    },
    bindListenerToAnchors() {
      const textElem = this.getTextElem();
      if (!textElem) { return; }
      const anchorTags = textElem.getElementsByTagName('a');
      for (let i = 0; i < anchorTags.length; i += 1) {
        anchorTags[i].addEventListener('click', () => {
          this.onAnchorClick(i, anchorTags[i]);
        });
        anchorTags[i].addEventListener('mousedown', () => {
          this.onAnchorMouseDown(i, anchorTags[i]);
        });
        if (anchorTags[i].style) {
          anchorTags[i].style.color = this.anchorColor ? this.anchorColor : this.$arStyle.color.purple500;
          anchorTags[i].style.textDecoration = anchorTags[i].style.textDecoration ? anchorTags[i].style.textDecoration : 'underline';
          anchorTags[i].style.cursor = anchorTags[i].style.cursor ? anchorTags[i].style.cursor : 'pointer';
        }
      }
    },
    // If you have anchor inside v-html, this will tell you when and which anchor gets clicked
    onAnchorClick(idx, anchor) {
      this.$emit('anchorClick', idx, anchor);
    },

    // Mousedown events fire before blur events on other components. So if you need to action your anchor before the blur occurs,
    // listen for anchorMouseDown instead of anchorClick. Despite its name, this event will also fire on touch events
    onAnchorMouseDown(idx, anchor) {
      this.$emit('anchorMouseDown', idx, anchor);
    },
  },
};

export default ARText;
